<template>
  <!-- hero section (Our Products) -->
  <div>
    <section class="section section-container-hero section-shaped hero my-0">
      <div class="shape"></div>
      <div class="container shape-container d-flex align-items-center">
        <div class="col px-0">
          <div class="row justify-content-center align-items-center">
            <div class="col-lg-7 text-center col-md-5 col-sm-5">
              <h2 class="display-2 text-white mb-5 hero-title">
                OUR PRODUCTS
              </h2>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Easyhomes desc -->
    <section>
      <div class="col px-0">
        <div class="justify-content-center align-items-center">
          <div class="container col-lg-10 col-md-7 mt-4">
            <p class="text-gray m-2 paraTEXT text-justify">
              Designed, manufactured, and installed precast fences in various
              terrains: on ground, sloping hills, rice fields, on top of
              retaining wall, on top of riprap, etc.
            </p>
            <p class="text-gray m-2 paraTEXT text-justify">
              Easyhomes Inc. is a precast fence building company offering a
              complete range of products and services. We have been in business
              for more than 15 years and have experience in precast projects
              within the residential, commercial, industrial, and infrastructure
              markets. Our innovative products and quality service allow us to
              provide superior value for our customers.
            </p>
          </div>
        </div>
      </div>
    </section>
    <!-- Higlighted Products -->
    <div v-for="(product, index) in items" :key="index">
      <ProductHighlight :product="product" :key="index" />
    </div>
  </div>
</template>

<script>
import product from "../database/products";
import ProductHighlight from "./components/products/ProductHighlight"

export default {
  name: "our-products",
  components: {
    ProductHighlight,
  },
  data() {
    return {
      items: [],
    };
  },
  created() {
    this.retrieveAll();
  },
  methods: {
    async retrieveAll() {
      try {
        const data = await product.retrieveAll();
        this.items = data.sort((a, b) => a.dateCreated - b.dateCreated);
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.hero {
  background-image: url("/img/commons/optimized/heroprecast.png");
  background-attachment: fixed;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.hero-title {
  width: 100%;
  font-size: 3rem;
  margin-top: 50px;
  margin-left: -350px;
  text-shadow: 1px 1px black;
}

.paraTEXT {
  font-weight: 500;
  font-size: 1.1rem;
}

.container {
  max-width: 95.33333%;
}

.components {
  line-height: 6px;
}

.inquire {
  color: #eda711;
}

.inquire:hover {
  color: white !important;
  background-color: #eda711 !important;
}

/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  .hero {
    height: 500px;
  }

  .hero-title {
    margin-left: 0;
    font-size: 2.5rem;
  }
}

/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {
  .hero {
    height: 500px;
  }

  .hero-title {
    margin-left: 0;
  }
}

/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
  .hero {
    height: 500px;
  }

  .hero-title {
    margin-left: -12px;
    font-size: 4rem;
  }
}

/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
  .hero-title {
    margin-left: -40% !important;
  }
}

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {
  .hero {
    height: 550px;
  }

  .hero-title {
    margin-left: -50% !important;
  }
}
</style>
